import { Component, inject, computed } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MinimizedItemsService } from '../../../services/minimized-items.service';

@Component({
  selector: 'app-minimized-bar',
  standalone: true,
  imports: [
    MatButtonModule,
    MatIconModule,
    MatTooltipModule,
    MatToolbarModule,
  ],
  templateUrl: './minimized-bar.html',
  styleUrls: ['./minimized-bar.scss'],
})
export class MinimizedBar {
  private minimizedItemsService = inject(MinimizedItemsService);

  readonly items = this.minimizedItemsService.items;
  readonly hasItems = this.minimizedItemsService.hasMinimizedItems;

  restore(itemId: string): void {
    this.minimizedItemsService.restore(itemId);
  }

  close(itemId: string, event: Event): void {
    event.stopPropagation();
    const item = this.items().find((minimizedItem) => minimizedItem.id === itemId);
    if (item) {
      item.dialogRef.close();
      this.minimizedItemsService.remove(itemId);
    }
  }

  closeAll(): void {
    const allItems = this.items();
    allItems.forEach((item) => {
      item.dialogRef.close();
      this.minimizedItemsService.remove(item.id);
    });
  }
}
